import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

import bg from './assets/bg.png'
import bg_mob from './assets/bg_mob.png'

export const Wrapper = styled.div`
  padding-top: ${em(40)};
  padding-bottom: ${em(40)};
  background-color: #E2E8DE;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(${bg_mob});
  background-position: right bottom;
  background-size: 235px auto;

  ${p => p.theme.mq.upLg} {
    background-size: contain;
    padding-top: ${em(70)};
    padding-bottom: ${em(30)};
    background-image: url(${bg});
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;

  ${p => p.theme.mq.downMd} {
  }
`

export const Title = styled(Text)`
  margin-bottom: ${em(10, 25)};
  font-weight: 300!important;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(558, 50)};
    margin-bottom: ${em(20, 50)};
  }

  span {
    font-weight: 500;
  }
`

export const Description = styled(Text)`
  margin-bottom: ${em(40, 16)};

  ${p => p.theme.mq.upLg} {
    max-width: ${em(603, 22)};
    margin-bottom: ${em(55, 22)};
  }
`

export const Disclaimer = styled(Text)`
  color: var(--color-D50);
  max-width: ${em(234, 14)};

  ${p => p.theme.mq.upLg} {
    max-width: ${em(603, 22)};
    margin-bottom: ${em(55, 22)};
  }
`

export const LogosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: ${em(170)};
  gap: ${em(10)};
  margin-bottom: ${em(20)};

  ${p => p.theme.mq.upLg} {
    width: ${em(410)};
    grid-template-columns: repeat(6, 1fr);
    margin-bottom: ${em(15)};

    svg {
      width: 35px;
    }

    & > div:nth-of-type(4) {
      svg {
        width: ${em(48)}
      }
    }

    & > div:nth-of-type(5) {
      svg {
        width: ${em(44)}
      }
    }
  }

  svg {
    width: 28px;
  }

  & > div:nth-of-type(4) {
    svg {
      width: ${em(40)}
    }
  }

  & > div:nth-of-type(5) {
    svg {
      width: ${em(40)}
    }
  }
`

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${em(50)};
  height: ${em(50)};
  background-color: var(--color-W100);
  border-radius: 100%;

  ${p => p.theme.mq.upLg} {
    width: ${em(60)};
    height: ${em(60)};
  }
`
